import { Component, Input } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PlatformCompanyRegistrationDto } from '@well/platform-administration/company/domain';
import { constants } from '@well/infra/constants';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabel } from 'primeng/floatlabel';
import { FormInlineErrorDirective } from '@irian-ro/shared-ui';

@Component({
    selector: 'well-platform-company-registration-inputs',
    imports: [FloatLabel, FormsModule, TranslateModule, InputTextModule, FormInlineErrorDirective],
    templateUrl: './platform-company-registration-inputs.component.html',
    styleUrls: ['./platform-company-registration-inputs.component.scss'],
    viewProviders: [constants.nestedTemplateFormsViewProviders]
})
export class PlatformCompanyRegistrationInputsComponent {
  @Input() platformCompanyRegistrationDTO: PlatformCompanyRegistrationDto = new PlatformCompanyRegistrationDto();

}
